import script from "./NamaPengantinDynalight.vue?vue&type=script&setup=true&lang=js"
export * from "./NamaPengantinDynalight.vue?vue&type=script&setup=true&lang=js"

import "./NamaPengantinDynalight.vue?vue&type=style&index=0&id=7fc5eca5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fc5eca5"]])

export default __exports__